export default {
    "fr-FR": `
tr-active = Réactiver
tr-title-inactive = Désactivation temporaire
tr-explication-inactive = Vous pouvez désactiver temporairement la commmande en ligne, et la réactiver lorsque vous le souhaitez.
tr-inactive = Désactiver
tr-button-take-away = A emporter
tr-button-see-cart = Voir la carte
tr-title-address = Mon adresse
tr-delivery-impossible = Livraison impossible
tr-button-choose-address = Choisir
tr-button-fill-fields = Veuillez remplir les champs
tr-address-not-found = Vous ne trouvez pas votre adresse ?
tr-form-street =
.placeholder = Rue
tr-form-zip-code =
    .placeholder = Code postal
tr-form-city =
    .placeholder = Ville
tr-form-first-name =
    .placeholder = Prénom
tr-form-last-name =
    .placeholder = Nom
tr-form-phone =
    .placeholder = Téléphone
tr-form-address =
    .placeholder = Adresse
tr-title-page-menu = la carte
tr-quantity-extra-selector = Quantité :
tr-button-remove-product = Supprimer le produit
tr-button-validate = Valider
tr-title-cart = Mon panier
tr-contact-information = Informations
tr-contact-information-delivery = Coordonnées de livraison
tr-total-order = Total :
tr-subtotal-order = Sous-total :
tr-price-delivery = Frais de livraison :
tr-title-order-resume = Ma commande
tr-title-order-status = Statut de votre commande
tr-title-pay = Paiement
tr-pay-info = Aucun prélèvement ne sera effectué si la commande n'est pas validée par le restaurant
tr-pay-warning = Pour les paiements 3DSecure, pensez à retourner sur cette page après la validation sur votre application bancaire.
tr-pay-warning-bis = Votre commande ne sera pas validée ni préparée tant que vous n'avez pas reçu un mail de confirmation.
tr-pay-order = Valider ma commande
tr-expected-delivery = Livraison prévue dans
tr-expected-take-away = Commande prévue pour
tr-contact-bank = Coordonnées bancaires
tr-button-back = Retour
tr-title-address-user = Adresse
tr-modify-contact = Modifier les coordonnées
tr-title-menu = Carte
tr-admin-error-data-modify = Un problème est survenu lors de la modification de vos informations, veuillez réessayer plus tard.
tr-admin-modify-module-active = Jusqu'à nouvel ordre
tr-admin-modify-module-today = Pour aujourd'hui
tr-admin-data-general = Informations générales
tr-admin-name-restaurant = Nom de l'établissement *
tr-admin-email = Email de contact *
tr-title-phone = Téléphone
tr-admin-sentence-interface = Nom affiché sur l'interface de commande en ligne
tr-admin-concept = Description courte (facultatif)
tr-admin-describe-concept = Description courte de l'établissement, ex : Le fin gourmet à domicile
tr-admin-change = Vos changements ont bien été pris en compte.
tr-admin-module-disabled = La commande en ligne est désactivée jusqu'à nouvel ordre
tr-admin-for-today = La commande en ligne est désactivée pour le { $hour }
tr-admin-module-active = La commande en ligne est activée
tr-admin-module-not-active = Désactiver le module
tr-error-message = Une erreur est survenue
tr-error-input-address = L'adresse postal est introuvable
tr-error-address = Nous rencontrons un problème avec l'envoi de l'adresse
tr-admin-what-address-restaurant = Quelle est l'adresse de votre établissement ?
tr-admin-form-geoloc = Entrer une adresse pour la géolocaliser :
tr-admin-form-name-street = Nom de la voie * :
tr-admin-form-zip-code = Code postal * :
tr-admin-form-city = Ville * :
tr-admin-form-country = Pays * :
tr-admin-form-complement = Complément :
tr-admin-longitude = Longitude :
tr-admin-latitude = Latitude :
tr-admin-monday = Lundi
tr-admin-tuesday = Mardi
tr-admin-wednesday = Mercredi
tr-admin-thursday = Jeudi
tr-admin-friday = Vendredi
tr-admin-saturday = Samedi
tr-admin-sunday = Dimanche
tr-admin-morning = Midi
tr-admin-evening = Soir
tr-admin-error-save-data = Oups... nous rencontrons un problème avec l'enregistrement de vos données, veuillez réessayer plus tard.
tr-admin-error-modify-data = Oups.. nous rencontrons un problème avec la modification de vos données, veuillez réessayer plus tard.
tr-range-time-empty = Aucun horaire prévu
tr-admin-hour-start = Début
tr-admin-hour-end = Fin
tr-admin-day = Jour(s)
tr-range-closed = Aucune période de fermeture prévue
tr-create-range-closed = Créer une période de fermeture
tr-error-time-range = Merci de renseigner d’abord l’heure de fin du créneau.
tr-create-time-range = Créer une plage horaire
tr-admin-schedule-hour = Horaires de commande
tr-admin-change-save = Vos changements ont bien été pris en compte.
tr-admin-days-closed = Jours de fermeture
tr-admin-click-here = Configurer votre carte
tr-admin-manage-cart = Configurer votre carte :
tr-admin-how-order-delivered = Mode de validation des commandes sur iPad :
tr-admin-how-long-prepare-order = Temps de préparation des commandes :
tr-admin-label-prepare-order = En minutes
tr-admin-automatically-validation = Validation automatique
tr-admin-manually-validation = Validation manuelle
tr-admin-change-error = Une erreur est survenue
tr-admin-connect-stripe = Connectez-vous à Stripe
tr-admin-create-account-stripe = Créez votre compte sur Stripe ou connectez-vous à un compte existant
tr-admin-account-associate = Compte associé avec Stripe
tr-admin-not-connect = Non-connecté
tr-admin-connect = Connecté
tr-admin-tuto1-facebook = 1) Si ce n’est pas déjà fait, connectez-vous à votre compte Facebook
tr-admin-tuto2-facebook = 2) Sélectionnez la page de votre restaurant afin d’y intégrer le module
tr-admin-tuto3-facebook = 3) Accédez aux paramètres de votre page Facebook pour choisir la position du module sur votre page
tr-admin-tuto4-facebook = Comment ajouter un bouton “Commandez en ligne” sur votre Page Facebook
tr-admin-tuto5-facebook =Ajouter un bouton en haut de votre page Facebook permettra à vos clients d’accéder à votre module de commande en ligne notamment sur mobile.
tr-admin-copy-link = Lien à copier :
tr-admin-link-copied = Le lien a bien été copié dans votre presse-papier.
tr-admin-integrate-module-facebook = Comment intégrer le module sous forme d'un onglet sur votre page Facebook ?
tr-admin-module-facebook-connected = Votre module de commande en ligne est bien connecté avec votre caisse.
tr-admin-integrate-module-facebook2 = Intégrer le module sous forme d’onglet
tr-admin-hours-open = Veuillez renseigner vos horaires d’ouverture à la commande en ligne avant de commencer l’intégration du module.
tr-admin-tuto6-facebook = Sur votre page Facebook, le module de commande en ligne peut être accessible de deux façons à vos clients:
tr-admin-tuto7-facebook = via un onglet(1)
tr-admin-tuto8-facebook = Attention cet onglet n’est disponible que pour les pages de 2000 J’aime minimum
tr-admin-tuto9-facebook = via un bouton d’action en haut de votre page(2)
tr-admin-tuto10-facebook = Un problème est survenu lors de la connexion entre votre caisse L'Addition et votre module de commande en ligne. Veuillez nous contacter pour résoudre ce problème : {mail}
tr-admin-tuto11-facebook = Intégration de votre module de commande en ligne
tr-admin-tuto12-facebook = Intégration sur votre page Facebook
tr-admin-tuto13-facebook = besoin d'aide
tr-admin-tuto14-facebook = Comment ajouter un bouton “Commandez en ligne” sur votre Page Facebook
tr-admin-tuto15-facebook = Comment intégrer le module sur votre page Facebook ?
tr-admin-tuto16-facebook = Le module est déjà intégré à votre page Facebook
tr-admin-tuto17-facebook = via le bouton d’action
tr-admin-connect-addition = Connexion avec votre caisse L'Addition
tr-admin-tuto18-facebook = Intégrer le module à ma page Facebook
tr-admin-command = La commande en ligne
tr-admin-error-url = Cette url n’est pas disponible, veuillez la modifier
tr-admin-same-url = Cette URL vous appartient déjà
tr-admin-hour-activation = Activation
tr-admin-hour-slot = Créneau
tr-admin-days-open= Jour ouvert
tr-admin-add-close = Ajouter période de fermeture
tr-admin-add-slot = Ajouter un créneau
tr-deconnect = Déconnexion
tr-admin-manage-module = Configuration de votre module de commande en ligne
tr-link-general = Général
tr-link-address = Adresse
tr-link-hours = Horaires
tr-link-cart = Carte
tr-link-logistics = Logistique
tr-link-stripe = Stripe
tr-link-publication = Publication
tr-publication-title-step = Pour activer la réception des commandes sur votre iPad principal :
tr-publication-step1 = Faites une synchronisation manuelle (dans les Réglages > A propos)
tr-publication-step2 = Relancez l’application L’Addition
tr-publication-step3 = Allez dans les Réglages > Intégration partenaires > activez le bouton “Activation des modules partenaires”
tr-error-serveur-title = Oups ...
tr-error-serveur-message = Nous rencontrons actuellement un problème de communication avec nos serveurs, veuillez réessayer plus tard.
restaurant-not-ready = Le restaurant n'est pas prêt.
tr-url-wrong = La page que vous recherchez n’existe pas, merci de vérifier l’url saisie
tr-extra-title = Suppléments
first-part-cgu = J'accepte les
second-part-cgu = conditions générales d'utilisation
type-one-extra = Facultatif - 1 max
type-mandatory-extra = Obligatoire
type-option-extra = Facultatif
type-option2-extra = Facultatif - {$maximum} max
type-mandatory3-extra = Obligatoire - {$minimum} min
type-mandatory4-extra = Obligatoire - {$minimum} à {$maximum} max
tr-add-comments = Ajouter un commentaire
tr-textarea-comments =
    .placeholder = Message, allergies...
tr-shopping-cart = Panier
tr-ready-order = Votre commande sera prête aux alentours de
tr-wait-validation = En attente de validation
tr-order-accepted = Validée
tr-order-declined = Annulée
tr-wait-validation-info = Votre commande sera validée dès lors que le restaurant l'aura prise en compte ; aucun prélèvement n'est effectué jusqu'à ce que la commande soit validée.
tr-payment-info = Faites glissez pour voir la suite
tr-collect-hour = Retrait de ma commande -
tr-collect-planif = Planifier
tr-collect-near-hour = Au plus tôt
tr-collect = Planifiez l'heure de retrait de votre commande
tr-display-my-cart = Afficher mon panier
tr-title-recap = Récapitulatif
tr-name-app = La commande en ligne
tr-general-error-1 = Oups... Nous rencontrons actuellement un problème avec vos identifiants. Nous vous invitons à vous reconnecter.
tr-general-error-2 = Si l'erreur persiste, veuillez nous contacter à l'adresse mail suivante :
tr-connect-button = Connexion
tr-error-cart = Une erreur s'est produite lors de la validation de votre commande. Nous vous invitons à vérifier votre panier et réessayer.
tr-error-cart-2 = Une erreur s’est produite lors de la validation de votre commande. Nous vous invitons à ressaisir votre commande et réessayer.
tr-error-cart-3 = Votre commande est déjà en cours de traitement. Nous vous invitons à attendre le mail de confirmation du restaurant.
tr-error-cart-4 = Le(s) produit(s) { $products } de votre commande sont en rupture. Nous vous invitons à ressaisir votre commande et réessayer.
tr-error-hours = Une erreur s'est produite lors de la validation de votre commande. Nous vous invitons a réessayer quand le restaurant sera ouvert.
tr-error-cart-payment = Une erreur s’est produite lors de la validation de votre paiement. Nous vous invitons à vérifier vos coordonnées bancaires et réessayer.
tr-error-sum = Le montant minimum requis pour passer commande est de 0,50€.
tr-error-form = Une erreur s'est produite sur le formulaire de paiement, veuillez réessayer.
tr-tooltip-max-qty = Quantité maximum atteinte
tr-optionnal-category = Optionnel
tr-mandatory-category = Obligatoire
tr-order-take-to = Commande prise à :
tr-order-number = N° commande : 
tr-select-day = Veuillez sélectionner un jour pour créer/modifier une plage horaire
tr-update-url = Personnaliser votre url :
tr-example-url =
    .placeholder = ex : mon-restaurant
tr-mister = Mr
tr-miss = Mme
tr-extra-selected-menu = Modifier la sélection
tr-error-connection-ipad = La connexion avec le restaurant n'a pas pu être établie.
tr-error-connection-ipad2 = Si le problème persiste, veuillez contacter le restaurateur.
tr-error-check-customer-ipad = Une erreur s'est produite avec le restaurant.
tr-error-user-data = Une erreur s'est produite avec vos informations
tr-error-connection-ipad3 = La connexion avec le restaurant n'a pas pu être établie, veuillez réessayer dans une minute. Si le problème persiste, contactez le restaurateur.
tr-closing-date = Le restaurant est fermé, il ouvrira ses portes le 
tr-module-disabled = {$restaurantName} ne propose pas la commande en ligne actuellement.
tr-payment-unavailable = Le restaurant n’est pas encore prêt à prendre les commandes, veuillez réessayer ultérieurement.
tr-next-hour = Le restaurant ouvrira à 
tr-next-day = Le prochain jour d'ouverture est le 
tr-open = Le service est ouvert.
tr-service-closed = Le restaurant n’est pas encore prêt à prendre les commandes, veuillez réessayer dans quelques instants.
tr-close-without-date = Le restaurant ré-ouvrira prochainement.
tr-order-available = Passez commande à partir de
tr-order-preorder = Passez commande et récupérez-la à partir de 
tr-order-preorder-checkout = Passez commande et récupérez-la à partir de 
tr-order-saved = Votre panier est bien sauvegardé, vous pourrez le valider lorsque le restaurant sera ouvert, dès
tr-retry = Réessayer
tr-redirect-to-menu = Retour vers la carte
tr-instant-error= Une erreur s'est produite.
tr-error-cart-payment-1 = Nous vous invitons à vérifier vos coordonnées bancaires et réessayer.
tr-button-reValidate = Réessayer
tr-closed-today = Fermé aujourd'hui
tr-cmd-available-until = Commande possible jusqu'à { $time }
tr-next-opening-today = La prochaine ouverture est aujourd'hui à { $time }
tr-error-slot-frozen = Le créneau sélectionné n'est plus disponible, merci d'en sélectionner un autre.
tr-no-slot-available = Aucun créneau n'est disponible. Veuillez commander ultérieurement.
tr-next-opening = La prochaine ouverture est { $day }à { $time }
tr-closed-now = Fermé pour le moment
tr-order-out-of-hours = Commande non disponible pour le moment
`,
    "es-ES": `
tr-active = Reactivar
tr-title-inactive = Desactivación temporal
tr-explication-inactive = Puede desactivar temporalmente el pedido online y reactivarlo cuando lo desee.
tr-inactive = désactivar
tr-button-take-away = Para llevar
tr-button-see-cart = Ver la carta
tr-title-address = Mi dirección
tr-delivery-impossible = envío no disponible
tr-button-choose-address = Escoger
tr-button-fill-fields = Rellene los campos
tr-address-not-found = No encuentra su dirección ?
tr-form-street =
    .placeholder = Calle
tr-form-zip-code =
    .placeholder = Código postal
tr-form-city =
    .placeholder = Localidad
tr-form-first-name =
    .placeholder = Nombre
tr-form-last-name =
    .placeholder = Apellidos
tr-form-phone =
    .placeholder = Teléfono
tr-form-address =
    .placeholder = Dirección
tr-title-page-menu = la carta
tr-quantity-extra-selector = Cantidad :
tr-button-remove-product = Eliminar el producto
tr-button-validate = Validar
tr-title-cart = Mi cesta
tr-contact-information = Información
tr-contact-information-delivery = Datos de la de entrega
tr-total-order = Total pedido :
tr-subtotal-order = Subtotal :
tr-price-delivery = Gastos de envío :
tr-title-order-resume = Mi pedido
tr-title-order-status = Estado de su pedido
tr-title-pay = Pagar
tr-pay-order = Pagar mi pedido
tr-expected-delivery = Entrega prevista en
tr-contact-bank = Datos bancarios
tr-button-back = Volver
tr-title-address-user = Dirección
tr-modify-contact = Modificar los datos
tr-title-menu = La carta
tr-admin-error-data-modify = ha surgido un problema con la modificación de su información, por favor, inténtelo más tarde
tr-admin-modify-module-active = Hasta nueva orden
tr-admin-modify-module-today = Para hoy
tr-admin-data-general = Información general
tr-admin-name-restaurant = Nombre del establecimiento
tr-admin-email = Email de contacto
tr-title-phone = Teléfono
tr-admin-sentence-interface = Nombre mostrado en la interfaz de pedido en línea
tr-admin-concept = Eslogan
tr-admin-describe-concept = Eslogan del establecimiento, ej : El templo de la carne
tr-admin-change = Sus cambios han sido realizados correctamente.
tr-admin-module-disabled = El pedido online está desactivado
tr-admin-for-today = para llevar
tr-admin-module-active = el pedido online está activado
tr-admin-module-not-active = Desactivar el módulo
tr-error-input-address = La dirección postal no se puede encontrartr-error-input-address = The postal address cannot be found
tr-error-address = hay un problema con el envío de la dirección
tr-admin-what-address-restaurant = ¿ Cuál es la dirección de su establecimiento ?
tr-admin-form-geoloc = Introducir una dirección para geolocalizarla :
tr-admin-form-name-street = Nombre de la vía* :
tr-admin-form-zip-code = Código postal* :
tr-admin-form-city = Localidad* :
tr-admin-form-country = País* :
tr-admin-form-complement = Datos adicionales :
tr-admin-longitude = Longitud :
tr-admin-latitude = Latitud :
tr-admin-monday = Lunes
tr-admin-tuesday = Martes
tr-admin-wednesday = Miércoles
tr-admin-thursday = Jueves
tr-admin-friday = Viernes
tr-admin-saturday = Sábado
tr-admin-sunday = Domingo
tr-admin-morning = mediodía
tr-admin-evening = noche
tr-admin-error-save-data = Ups, hemos detectado un problema con la grabación de sus datos
tr-admin-error-modify-data = Ups, hemos detectado un problema con la modificación de sus datos. Por favor, inténtelo más tarde
tr-admin-hour-start = Inicio
tr-admin-hour-end = Fin
tr-admin-day = Día
tr-admin-days-open= Jornada de apertura
tr-admin-schedule-hour = Horario de pedidos
tr-admin-change-save = Sus cambios se han efectuado.
tr-admin-click-here = Personaliza tu carta
tr-admin-manage-cart = Configurar su carta :
tr-error-time-range = Por favor, introduzca primero la hora final de la ranura.
tr-admin-how-order-delivered = Cómo se han entregado sus pedidos ?
tr-admin-how-long-prepare-order = Tiempo de preparación de los pedidos :
tr-admin-label-prepare-order = En minutos
tr-admin-automatically-validation = Validación automática
tr-admin-manually-validation = Validación manual
tr-admin-change-error = Ha sobrevenido un error
tr-admin-connect-stripe = Conéctese a Stripe
tr-admin-create-account-stripe = Cree su cuenta de Stripe o entre en una cuenta existente
tr-admin-account-associate = Cuenta asociada a Stripe
tr-admin-not-connect = no conectada
tr-admin-connect = conectada
tr-admin-tuto1-facebook = 1) Si aún no lo ha hecho, conéctese a su cuenta de Facebook
tr-admin-tuto2-facebook = 2) Seleccione la página de su restaurante para integrar el módulo
tr-admin-tuto3-facebook = 3) Acceda a los parámetros de su página de Facebook para escoger la posición del módulo en su página
tr-admin-tuto4-facebook = Cómo añadir un botón "reservar" en su página de Facebook
tr-admin-tuto5-facebook = Añadir un botón arriba de su página de Facebook permitirá a sus clientes acceder a su módulo de reserva particularmente desde el móvil
tr-admin-copy-link = Enlace a copiar :
tr-admin-link-copied = El enlace se ha copiado correctamente en el portapapeles.
tr-admin-integrate-module-facebook = Cómo integrar el módulo como pestaña en su página de Facebook ?
tr-admin-module-facebook-connected = Su módulo de pedidos online se ha conectado correctamente.
tr-admin-integrate-module-facebook2 = Integrar el módulo como pestaña
tr-admin-hours-open = Por favor, especifique sus horarios de apertura antes de empezar la integración del módulo.
tr-admin-tuto6-facebook = En su página de Facebook, su cliente puede acceder de dos maneras al módulo de reserva:
tr-admin-tuto7-facebook = mediante una pestaña(1)
tr-admin-tuto8-facebook = Cuidado, esta pestaña solo está disponible para las páginas que tienen, como mínimo, 2000 Me Gusta
tr-admin-tuto9-facebook = mediante un botón en la parte superior de su página(2)
tr-admin-tuto10-facebook = Hay un problema sobrevenido con la conexión entre su caja L'Addition y su módulo de reserva. Por favor, contacte con nosotros para resolver este problema : {mail}
tr-admin-tuto11-facebook = Integración de su módulo de reserva
tr-admin-tuto12-facebook = Integración en su página de Facebook
tr-admin-tuto13-facebook = Necesito ayuda
tr-admin-tuto14-facebook = Cómo añadir un botón "Reservar" en su página de Facebook
tr-admin-tuto15-facebook = Cómo integrar el módulo en su página de Facebook ?
tr-admin-tuto16-facebook = El módulo ya está integrado en su página de Facebook
tr-admin-tuto17-facebook = Integrar el módulo mediante el botón de acción
tr-admin-connect-addition = conexión con su caja L'Addition
tr-admin-tuto18-facebook = Integrar el módulo en mi página de Facebook
tr-admin-same-url = Esta url ya es tuya 
tr-admin-command = Pedido online
tr-admin-hour-activation = Activación
tr-admin-hour-slot = Nicho
tr-admin-add-close = Añadir período de cierre
tr-admin-add-slot = Añadir una ranura
tr-deconnect = Desconexión
tr-admin-manage-module = Configuración de su módulo de pedido online
tr-link-general = General
tr-link-address = Dirección
tr-link-hours = Horarios
tr-link-cart = Carta
tr-link-logistics = Logística
tr-link-stripe = Stripe
tr-link-publication = Publicación
tr-publication-title-step = Para habilitar la recepción de pedidos en tu iPad principal:
tr-publication-step1 = Realizar una sincronización manual (en Configuración > Acerca de)
tr-publication-step2 = Reinicie la aplicación de adición
tr-publication-step3 = 1. Vaya a Ajustes > Integración de socios > active el botón "Activar módulos de socios"
tr-error-serveur-title = Ups ...
tr-error-serveur-message = Actualmente hay un problema de conexión con nuestros servidores...
tr-optionnal-category = Optativo
tr-mandatory-category = Obligatorio
restaurant-not-ready = El restaurante no está listo.
tr-tooltip-max-qty = Cantidad máxima alcanzada
tr-textarea-comments =
    .placeholder = Mensaje, alergias...
tr-name-app = El pedido on line
tr-display-my-cart = Ver mi cesta
tr-title-recap = Resumen
tr-collect-near-hour = A la mayor brevedad
tr-collect-hour = Recogida de mi pedido -
tr-collect-planif = Planificar
tr-collect = Planifique el momento de recoger su pedido
tr-order-declined = Anulado
tr-order-accepted = Validado
tr-wait-validation = En espera de validación
tr-ready-order = Su pedido estará listo alrededor de la(s)
tr-shopping-cart = Cesta
tr-add-comments = Añadir un comentario
tr-url-wrong = La dirección URL no coincide
tr-extra-title = Suplementos
first-part-cgu = Acepto la
second-part-cgu = condiciones generales de uso
type-option-extra = Opcional
type-option2-extra = Opcional - {$maximum} máx
type-mandatory-extra = Obligatorio
type-mandatory3-extra = Obligatorio - {$minimum} mín
type-mandatory4-extra = Obligatorio - {$minimum} à {$maximum} máx
type-one-extra = Facultativo - 1 max
tr-general-error-1 = Ups... Hemos detectado un problema con su identificación. Le rogamos se conecte de nuevo.
tr-general-error-2 = Si el error persiste, por favor, contáctenos en la siguiente dirección correo electrónico :
tr-connect-button = Conexión
tr-error-cart = Se ha producido un error en la validación de su pedido. Le invitamos a comprobar su cesta e intentarlo de nuevo.
tr-error-cart-2 = Se ha producido un error durante la validación de su pedido. Por favor, puede volver a introducir su pedido, gracias.
tr-error-cart-3 = Su pedido ya está siendo procesado. Le invitamos a esperar el correo electrónico de confirmación del restaurante.
tr-error-cart-4 = El(los) producto(s) { $products } de su pedido están agotados. Le invitamos a volver a realizar su pedido e intentarlo de nuevo.
tr-error-cart-payment = Se produjo un error durante la validación de su pago. Le invitamos a comprobar sus datos bancarios y a intentarlo de nuevo.
tr-error-sum = El importe mínimo para realizar un pedido es de 0,50€.
tr-error-form = Se ha producido un error en el formulario de pago, por favor inténtelo de nuevo.
tr-create-range-closed = Crear un período de cierre
tr-create-time-range = Crear un intervalo de tiempo
tr-admin-days-closed = Días de cierre
tr-expected-take-away = Entrega prevista
tr-order-take-to = Entrega prevista :
tr-range-closed = Especificar periodo de cierre previsto
tr-order-number = Número de pedido :
tr-select-day = Por favor seleccione un día para crear/editar una franja horaria
tr-update-url = Modifica tu url :
tr-example-url =
    .placeholder = ex: mi-restaurante
tr-mister = Sr
tr-miss = Sra
tr-range-time-empty = No hay un horario
tr-admin-error-url = Esta url no está disponible, por favor modifíquela
tr-url-wrong = La página que está buscando no existe, por favor, compruebe la url introducida
tr-extra-selected-menu = Modificar la selección
tr-error-connection-ipad = No se pudo establecer la conexión con el restaurante.
tr-error-connection-ipad2 = Si el problema persiste, comuníquese con el conservador.
tr-error-check-customer-ipad = Se ha producido un error con el restaurante.
tr-error-user-data = Se produjo un error con su información
tr-error-connection-ipad3 = No se pudo establecer la conexión con el restaurante, por favor, inténtelo de nuevo en un minuto. Si el problema persiste, por favor contacte con el restaurante.
tr-closing-date = El restaurante está cerrado, abrirá sus puertas en 
tr-module-disabled = {$restaurantName} actualmente no ofrece pedidos en línea.
tr-payment-unavailable = El restaurante no está preparado para recibir pedidos, inténtelo más tarde.
tr-next-hour = El restaurante abrirá sus puertas a las 
tr-next-day = El siguiente día de apertura es 
tr-open = El servicio está abierto.
tr-service-closed = El restaurante aún no está listo para recibir pedidos, por favor inténtelo de nuevo en unos momentos.
tr-close-without-date = El restaurante reabrirá pronto.
tr-order-available = Haz tu pedido a partir de las
tr-order-saved = Su cesta esta guardada, podrá validarla cuando el restaurante esté abierto, a las
tr-retry = Inténtelo de nuevo
tr-redirect-to-menu = Volver al menú
tr-instant-error= Se ha producido un error
tr-error-cart-payment-1 = Le invitamos a comprobar sus datos bancarios y a intentarlo de nuevo.
tr-button-reValidate = Inténtalo de nuevo
tr-closed-today = Cerrado hoy
tr-cmd-available-until = Pedido posible hasta { $time }
tr-next-opening-today = La próxima apertura es hoy a las { $time }
tr-next-opening = La próxima apertura es el { $day } a las { $time } horas
tr-closed-now = Cerrado por el momento
tr-order-out-of-hours = Pedido no disponible en este momento
`,
    ca: `
tr-active = Reactivar
tr-title-inactive = Desactivación temporal
tr-explication-inactive = Puede desactivar temporalmente el pedido online y reactivarlo cuando lo desee.
tr-inactive = désactivar
tr-button-take-away = Para llevar
tr-button-see-cart = Ver la carta
tr-title-address = Mi dirección
tr-delivery-impossible = envío no disponible
tr-button-choose-address = Escoger
tr-button-fill-fields = Rellene los campos
tr-address-not-found = No encuentra su dirección ?
tr-form-street =
    .placeholder = Calle
tr-form-zip-code =
    .placeholder = Código postal
tr-form-city =
    .placeholder = Localidad
tr-form-first-name =
    .placeholder = Nombre
tr-form-last-name =
    .placeholder = Apellidos
tr-form-phone =
    .placeholder = Teléfono
tr-form-address =
    .placeholder = Dirección
tr-title-page-menu = la carta
tr-quantity-extra-selector = Cantidad :
tr-button-remove-product = Eliminar el producto
tr-button-validate = Validar
tr-title-cart = Mi cesta
tr-contact-information = Información
tr-contact-information-delivery = Datos de la de entrega
tr-total-order = Total pedido :
tr-subtotal-order = Subtotal :
tr-price-delivery = Gastos de envío :
tr-title-order-resume = Mi pedido
tr-title-order-status = Estado de su pedido
tr-title-pay = Pagar
tr-pay-order = Pagar mi pedido
tr-expected-delivery = Entrega prevista en
tr-contact-bank = Datos bancarios
tr-button-back = Volver
tr-title-address-user = Dirección
tr-modify-contact = Modificar los datos
tr-title-menu = La carta
tr-admin-error-data-modify = ha surgido un problema con la modificación de su información, por favor, inténtelo más tarde
tr-admin-modify-module-active = Hasta nueva orden
tr-admin-modify-module-today = Para hoy
tr-admin-data-general = Información general
tr-admin-name-restaurant = Nombre del establecimiento
tr-admin-email = Email de contacto
tr-title-phone = Teléfono
tr-admin-sentence-interface = Nombre mostrado en la interfaz de pedido en línea
tr-admin-concept = Eslogan
tr-admin-describe-concept = Eslogan del establecimiento, ej : El templo de la carne
tr-admin-change = Sus cambios han sido realizados correctamente.
tr-admin-module-disabled = El pedido online está desactivado
tr-admin-for-today = para llevar
tr-admin-module-active = el pedido online está activado
tr-admin-module-not-active = Desactivar el módulo
tr-error-input-address = La dirección postal no se puede encontrartr-error-input-address = The postal address cannot be found
tr-error-address = hay un problema con el envío de la dirección
tr-admin-what-address-restaurant = ¿ Cuál es la dirección de su establecimiento ?
tr-admin-form-geoloc = Introducir una dirección para geolocalizarla :
tr-admin-form-name-street = Nombre de la vía* :
tr-admin-form-zip-code = Código postal* :
tr-admin-form-city = Localidad* :
tr-admin-form-country = País* :
tr-admin-form-complement = Datos adicionales :
tr-admin-longitude = Longitud :
tr-admin-latitude = Latitud :
tr-admin-monday = Lunes
tr-admin-tuesday = Martes
tr-admin-wednesday = Miércoles
tr-admin-thursday = Jueves
tr-admin-friday = Viernes
tr-admin-saturday = Sábado
tr-admin-sunday = Domingo
tr-admin-morning = mediodía
tr-admin-evening = noche
tr-admin-error-save-data = Ups, hemos detectado un problema con la grabación de sus datos
tr-admin-error-modify-data = Ups, hemos detectado un problema con la modificación de sus datos. Por favor, inténtelo más tarde
tr-admin-hour-start = Inicio
tr-admin-hour-end = Fin
tr-admin-day = Día
tr-admin-days-open= Jornada de apertura
tr-admin-schedule-hour = Horario de pedidos
tr-admin-change-save = Sus cambios se han efectuado.
tr-admin-click-here = Personaliza tu carta
tr-admin-manage-cart = Configurar su carta :
tr-error-time-range = Por favor, introduzca primero la hora final de la ranura.
tr-admin-how-order-delivered = Cómo se han entregado sus pedidos ?
tr-admin-how-long-prepare-order = Tiempo de preparación de los pedidos :
tr-admin-label-prepare-order = En minutos
tr-admin-automatically-validation = Validación automática
tr-admin-manually-validation = Validación manual
tr-admin-change-error = Ha sobrevenido un error
tr-admin-connect-stripe = Conéctese a Stripe
tr-admin-create-account-stripe = Cree su cuenta de Stripe o entre en una cuenta existente
tr-admin-account-associate = Cuenta asociada a Stripe
tr-admin-not-connect = no conectada
tr-admin-connect = conectada
tr-admin-tuto1-facebook = 1) Si aún no lo ha hecho, conéctese a su cuenta de Facebook
tr-admin-tuto2-facebook = 2) Seleccione la página de su restaurante para integrar el módulo
tr-admin-tuto3-facebook = 3) Acceda a los parámetros de su página de Facebook para escoger la posición del módulo en su página
tr-admin-tuto4-facebook = Cómo añadir un botón "reservar" en su página de Facebook
tr-admin-tuto5-facebook = Añadir un botón arriba de su página de Facebook permitirá a sus clientes acceder a su módulo de reserva particularmente desde el móvil
tr-admin-copy-link = Enlace a copiar :
tr-admin-link-copied = El enlace se ha copiado correctamente en el portapapeles.
tr-admin-integrate-module-facebook = Cómo integrar el módulo como pestaña en su página de Facebook ?
tr-admin-module-facebook-connected = Su módulo de pedidos online se ha conectado correctamente.
tr-admin-integrate-module-facebook2 = Integrar el módulo como pestaña
tr-admin-hours-open = Por favor, especifique sus horarios de apertura antes de empezar la integración del módulo.
tr-admin-tuto6-facebook = En su página de Facebook, su cliente puede acceder de dos maneras al módulo de reserva:
tr-admin-tuto7-facebook = mediante una pestaña(1)
tr-admin-tuto8-facebook = Cuidado, esta pestaña solo está disponible para las páginas que tienen, como mínimo, 2000 Me Gusta
tr-admin-tuto9-facebook = mediante un botón en la parte superior de su página(2)
tr-admin-tuto10-facebook = Hay un problema sobrevenido con la conexión entre su caja L'Addition y su módulo de reserva. Por favor, contacte con nosotros para resolver este problema : {mail}
tr-admin-tuto11-facebook = Integración de su módulo de reserva
tr-admin-tuto12-facebook = Integración en su página de Facebook
tr-admin-tuto13-facebook = Necesito ayuda
tr-admin-tuto14-facebook = Cómo añadir un botón "Reservar" en su página de Facebook
tr-admin-tuto15-facebook = Cómo integrar el módulo en su página de Facebook ?
tr-admin-tuto16-facebook = El módulo ya está integrado en su página de Facebook
tr-admin-tuto17-facebook = Integrar el módulo mediante el botón de acción
tr-admin-connect-addition = conexión con su caja L'Addition
tr-admin-tuto18-facebook = Integrar el módulo en mi página de Facebook
tr-admin-same-url = Esta url ya es tuya 
tr-admin-command = Pedido online
tr-admin-hour-activation = Activación
tr-admin-hour-slot = Nicho
tr-admin-add-close = Añadir período de cierre
tr-admin-add-slot = Añadir una ranura
tr-deconnect = Desconexión
tr-admin-manage-module = Configuración de su módulo de pedido online
tr-link-general = General
tr-link-address = Dirección
tr-link-hours = Horarios
tr-link-cart = Carta
tr-link-logistics = Logística
tr-link-stripe = Stripe
tr-link-publication = Publicación
tr-publication-title-step = Para habilitar la recepción de pedidos en tu iPad principal:
tr-publication-step1 = Realizar una sincronización manual (en Configuración > Acerca de)
tr-publication-step2 = Reinicie la aplicación de adición
tr-publication-step3 = 1. Vaya a Ajustes > Integración de socios > active el botón "Activar módulos de socios"
tr-error-serveur-title = Ups ...
tr-error-serveur-message = Actualmente hay un problema de conexión con nuestros servidores...
tr-optionnal-category = Optativo
tr-mandatory-category = Obligatorio
restaurant-not-ready = El restaurante no está listo.
tr-tooltip-max-qty = Cantidad máxima alcanzada
tr-textarea-comments =
    .placeholder = Mensaje, alergias...
tr-name-app = El pedido on line
tr-display-my-cart = Ver mi cesta
tr-collect-near-hour = A la mayor brevedad
tr-collect-hour = Recogida de mi pedido -
tr-collect-planif = Planificar
tr-collect = Planifique el momento de recoger su pedido
tr-order-declined = Anulado
tr-order-accepted = Validado
tr-wait-validation = En espera de validación
tr-ready-order = Su pedido estará listo alrededor de la(s)
tr-shopping-cart = Cesta
tr-add-comments = Añadir un comentario
tr-url-wrong = La dirección URL no coincide
tr-extra-title = Suplementos
first-part-cgu = Acepto la
second-part-cgu = condiciones generales de uso
type-option-extra = Opcional
type-option2-extra = Opcional - {$maximum} máx
type-mandatory-extra = Obligatorio
type-mandatory3-extra = Obligatorio - {$minimum} mín
type-mandatory4-extra = Obligatorio - {$minimum} à {$maximum} máx
type-one-extra = Facultativo - 1 max
tr-general-error-1 = Ups... Hemos detectado un problema con su identificación. Le rogamos se conecte de nuevo.
tr-general-error-2 = Si el error persiste, por favor, contáctenos en la siguiente dirección correo electrónico :
tr-connect-button = Conexión
tr-error-cart = Se ha producido un error en la validación de su pedido. Le invitamos a comprobar su cesta e intentarlo de nuevo.
tr-error-cart-2 = Se ha producido un error durante la validación de su pedido. Por favor, puede volver a introducir su pedido, gracias.
tr-error-cart-3 = Su pedido ya está siendo procesado. Le invitamos a esperar el correo electrónico de confirmación del restaurante.
tr-error-cart-4 = El(s) producte(s) { $products } de la teva comanda estan esgotats. T'invitem a tornar a introduir la teva comanda i a intentar-ho de nou.
tr-error-cart-payment = Se produjo un error durante la validación de su pago. Le invitamos a comprobar sus datos bancarios y a intentarlo de nuevo.
tr-error-sum = El importe mínimo para realizar un pedido es de 0,50€.
tr-error-form = Se ha producido un error en el formulario de pago, por favor inténtelo de nuevo.
tr-create-range-closed = Crear un período de cierre
tr-create-time-range = Crear un intervalo de tiempo
tr-admin-days-closed = Días de cierre
tr-expected-take-away = Entrega prevista
tr-order-take-to = Entrega prevista :
tr-range-closed = Especificar periodo de cierre previsto
tr-order-number = Número de pedido :
tr-select-day = Por favor seleccione un día para crear/editar una franja horaria
tr-update-url = Modifica tu url :
tr-example-url =
    .placeholder = ex: mi-restaurante
tr-mister = Sr
tr-miss = Sra
tr-range-time-empty = No hay un horario
tr-admin-error-url = Esta url no está disponible, por favor modifíquela
tr-url-wrong = La página que está buscando no existe, por favor, compruebe la url introducida
tr-extra-selected-menu = Modificar la selección
tr-error-connection-ipad = No se pudo establecer la conexión con el restaurante.
tr-error-connection-ipad2 = Si el problema persiste, comuníquese con el conservador.
tr-error-check-customer-ipad = Se ha producido un error con el restaurante.
tr-error-user-data = Se produjo un error con su información
tr-error-connection-ipad3 = No se pudo establecer la conexión con el restaurante, por favor, inténtelo de nuevo en un minuto. Si el problema persiste, por favor contacte con el restaurante.
tr-closing-date = El restaurante está cerrado, abrirá sus puertas en 
tr-module-disabled = {$restaurantName} actualment no ofereix comandes en línia.
tr-next-hour = El restaurante abrirá sus puertas a las 
tr-next-day = El siguiente día de apertura es 
tr-open = El servicio está abierto.
tr-service-closed = El restaurante aún no está listo para recibir pedidos, por favor inténtelo de nuevo en unos momentos.
tr-payment-unavailable = El restaurant no està preparat per rebre comandes, torneu-ho a provar més tard.
tr-close-without-date = El restaurante reabrirá pronto.
tr-order-available = Fes la teva comanda a partir de les 
tr-order-saved = Su cesta esta guardada, podrá validarla cuando el restaurante esté abierto, a las
tr-retry = Inténtelo de nuevo
tr-redirect-to-menu = Tornar al menú
tr-instant-error= Se ha producido un error
tr-error-cart-payment-1 = Le invitamos a comprobar sus datos bancarios y a intentarlo de nuevo.
tr-button-reValidate = Inténtalo de nuevo
tr-closed-today = Tancat de moment
tr-cmd-available-until = Comandes possibles fins a les { $time }
tr-next-opening-today = La propera inauguració és avui a les { $time }
tr-next-opening = La propera obertura serà { $day } a les { $time }
tr-closed-now = Tancat de moment
tr-order-out-of-hours = La comanda no està disponible en aquests moments
`,
};
